<div class="toast-note hide" [class]="type">
    <div class="row">
        <div class="col">
            <i class="fa-solid fa-xmark close-icon" (click)="hideToast()"></i>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <i class="fa-solid" [class]="type === 'success' ? 'fa-check pe-2' : 'fa-x pe-2'"></i>
            {{ message }}
        </div>
    </div>
</div>
